module.exports = __webpack_public_path__ + "img/start.7712d7a6.svg";